<script>
	import BaseLayer from "./../components/BaseLayer.svelte";
</script>

<BaseLayer>
	<div class="m-4">
		<h3 class="page-title mb-4">Credits</h3>
		<p class="my-6">
			<b>Icons</b>: Font Awesome Pro 6.2.0 by @fontawesome - Copyright 2022 Fonticons, Inc. <br>
			Licence at <a class="underline" href="https://fontawesome.com/license">https://fontawesome.com/license</a>
		</p>

		<p class="my-6">
			<b>CAA</b>: The pictographic symbols used are the property of the Government of Aragón and have been created by Sergio Palao for <a class="underline" href="https://arasaac.org/">ARASAAC</a>, that distributes them under Creative Commons License BY-NC-SA.
			<br><br>
			Pictograms author: Sergio Palao. Origin: ARASAAC. Owner: Government of Aragon (Spain). License: CC (BY-NC-SA).

			<img src="assets/logo_ARASAAC.png" class="w-48 my-4 mx-auto" />
		</p>

		<h3 class="page-title mb-4">Disclaimers</h3>
		<p class="my-6">
			The European Commission’s support for the production of this publication does not constitute an endorsement of the contents, which reflect the views only of the authors, and the Commission cannot be held responsible for any use which may be made of the information contained therein. Project:  Hi-Ability – Developing social and professional skills through outdoor experiences.
			<br><br>
			<b>N. 2020-1-IT02-KA204-079809</b>
			<br><br>	

			<img src="assets/Co-Funded by the EU_POS.png" class="w-96 mx-auto" />
		</p>

		<h3 class="page-title mb-4">Licence</h3>
		<p class="my-6">
			The present software is distributed under the <b>GNU GPL 3.0</b> licence.<br>
			Here the <a class="underline" href="https://www.gnu.org/licenses/gpl-3.0-standalone.html">integral version of the licence</a>.
			<br><br>
			<b>Source code</b>: <a class="underline" href="https://gitlab.com/trekkify_projects/hi-ability">https://gitlab.com/trekkify_projects/hi-ability</a>
		</p>
	</div>

</BaseLayer>

